<template>
  <el-tooltip
    :content="text"
    :disabled="!showTip"
    :placement="placement"
  >
    <div
      ref="textDom"
      class="text-show-tip"
      :style="cssObject"
    >
      {{ text }}
    </div>
  </el-tooltip>
</template>
<script>
export default {
  name: 'TextShowTip',
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    },
    cssObject: {
      type: Object,
      default: function() {
        return {};
      }
    },
    placement: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {
      showTip: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.textDom.scrollWidth > this.$refs.textDom.clientWidth) {
        this.showTip = true;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.text-show-tip {
  width: 100%;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
